import crud from "./crud";
import crud_service from "@/services/crud";

const path = "battery_status";
const struct = {
  battery_id: null,
  time: null,
  energy_left: 0,
  battery_power: 0,
  frequency: null,
  grid: null,
  soe: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
  current: [],
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,

  setCurrent(state, items) {
    state.current = items;
  },
};

const actions = {
  ...generic.actions,

  // Recent statuses of one battery, newest first
  getHistory({ commit }, options) {
    const payload = {
      battery_id: options.battery_id,
      hours: options.hours || 24,
    };
    return new Promise((resolve) => {
      crud_service.fetch(`${path}/history`, payload).then((data) => {
        commit("nothing");
        resolve(Array.isArray(data) ? data : []);
      });
    });
  },

  // Latest status of every battery (one entry per battery)
  getCurrent({ commit }) {
    return new Promise((resolve) => {
      crud_service.fetch(`${path}/current`, {}).then((data) => {
        commit("setCurrent", data);
        resolve(data);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
